export default __webpack_public_path__ + "translate-chrome-ios-1.png";